// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7daf3d35","703":"738b8d77","787":"3b82a88e"}[chunkId] + ".chunk.js";
};